module.exports = __webpack_public_path__ + "static/media/3040.be586c35.jpg";